import React, { useEffect, useRef } from "react";
import { connect, useSelector } from "react-redux";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import payment_success from "../../../../assets/svgs/payment_success.svg";
import payment_failed from "../../../../assets/svgs/payment_failed.svg";
import Button from "../../Button/Button.jsx";
import { APP_NAME } from "../../../../lib/constants/globalConstant.js";
import { paymentModalStyles as styles } from "./PaymentModalForBuyPoints.tailwind.js";
import { PAYMENT_STATUS } from "../../../../lib/constants/globalConstant.js";
import { updatePurchasedPointsStatus } from "../../../../redux/slices/rewardSlice.js";
import CubeLoader from "../../Loaders/CubeLoader/CubeLoader.jsx";

const errorData = {
  Heading: "Payment Failed!",
  SubHeading: "Something went wrong",
  Message: "The payment for your points purchase was not completed. Please try again or contact support if the issue persists.",
};

const PaymentModalForBuyPoints = ({ isOpen, onClose, status, paymentIntent, updatePaymentInfoForPoints }) => {
  const hasUpdatedPayment = useRef(false); // Ref to track if payment status has been updated
  const { updatePurchasedPointsStatus, isUpdatingPurchasePointStatus } = useSelector((state) => state.reward);
  const { currentSeason } = useSelector((state) => state.seasons);

  const successData = {
    Heading: "Thank you",
    SubHeading: `For supporting your ${APP_NAME}`,
    Message: `Congratulations! Your ${updatePurchasedPointsStatus?.points} points have been successfully added to your account. Start redeeming rewards, leveling up, and enjoying all the exclusive benefits.`,
  };

  const data = status === PAYMENT_STATUS.SUCCEDED ? successData : errorData;
  const image = status === PAYMENT_STATUS.SUCCEDED ? payment_success : payment_failed;

  useEffect(() => {
    // API call to update payment status when modal opens
    window.history.replaceState({}, document.title, window.location.pathname);
    if (
      isOpen &&
      !hasUpdatedPayment.current &&
      paymentIntent &&
      currentSeason
    ) {
      const requestData = {
        paymentStatus: status,
        paymentIntentId: paymentIntent,
        seasonId: currentSeason?._id
      };

      updatePaymentInfoForPoints(requestData);
      hasUpdatedPayment.current = true; // Set ref to true to prevent additional calls
    }
  }, [paymentIntent, currentSeason]);

  return (
    <Modal
      open={isOpen} // Use the isOpen prop to control the modal's visibility
      onClose={() => {}} // Prevent closing when clicking outside
      disableAutoFocus
    >
      {(!hasUpdatedPayment.current || isUpdatingPurchasePointStatus) ? (
        <div className="w-full h-full flex items-center justify-center">
          <CubeLoader />
        </div>
      ) : (
        <div className={styles.container}>
          {/* close button */}
          <button onClick={onClose}>
            <CloseIcon
              sx={{
                position: "absolute",
                top: 10,
                right: 10,
                cursor: "pointer",
                fontSize: "16px",
              }}
            />
          </button>

          {/* main-content */}
          <div className={styles.innerContainer}>
            {/* center-icon */}
            <div
              className={`${styles.doneIcon} ${
                status === PAYMENT_STATUS.SUCCEDED ? "bg-[#E2FEEE]" : " w-[100%]"
              } `}
            >
              <img src={image} alt="Payment Message" className={`${ status === PAYMENT_STATUS.SUCCEDED ? "max-[30px]" : "max-w-[50px] w-[100%]"}`}/>
            </div>

            {/* texts */}
            <div
              className={`${
                status === PAYMENT_STATUS.SUCCEDED
                  ? styles.thankYouText
                  : styles.thankYouTextError
              }`}
            >
              {data.Heading}
              <div
                className={`${
                  status === PAYMENT_STATUS.SUCCEDED
                    ? styles.thankYouMessage
                    : styles.thankYouMessageError
                }`}
              >
                {data.SubHeading}
              </div>
            </div>
            <div className={styles.message}>{data.Message}</div>

            {/* close button */}
            <Button variant="primary" onClick={onClose}>
            {status === PAYMENT_STATUS.SUCCEDED ? "Account Home" : "Retry Payment"}
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => ({
  updatePaymentInfoForPoints: (data) => dispatch(updatePurchasedPointsStatus(data)),
});

export default connect(null, mapDispatchToProps)(PaymentModalForBuyPoints);
